import { lazy } from "react";
// User Profile — perfil del usuario logueado (incluye enrollment MFA).
const UserProfilePage = lazy(() => import("./UserProfilePage"));
export const userProfileRoutes = [
  { path: "/profile", element: <UserProfilePage /> },
];

export { UserProfilePage };
